<div class="ord-bg-gray-100 min-h-full flex flex-col">
  <section class="section max-w-5xl py-7 space-y-10 my-auto">
    <header class="text-center">
      <img
        [src]="IMAGES.logoPrimary.src"
        [alt]="IMAGES.logoPrimary.alt"
        class="w-48 mx-auto"
      />
    </header>
    <div>
      <router-outlet></router-outlet>
    </div>
  </section>
</div>
